import { minutesFromClientX, minutesToPercent, selectedSegments, stepMinutes } from "./timeline-range.js";
import { TimelineHandle } from "./TimelineHandle.js";
import { useEffect, useRef } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/components/RRule/DayTimelineRange.tsx
function DayTimelineRange({ durationMin, fromMin, lanes, onChangeFrom, onChangeTo, showHandles, showPeriodTrack, toMin }) {
	const trackRef = useRef(null);
	const dragEndRef = useRef(null);
	const onChangeFromRef = useRef(onChangeFrom);
	const onChangeToRef = useRef(onChangeTo);
	onChangeFromRef.current = onChangeFrom;
	onChangeToRef.current = onChangeTo;
	const periodTrackVisible = showPeriodTrack ?? true;
	const interactive = periodTrackVisible && Boolean(onChangeFrom && onChangeTo);
	const handlesVisible = (showHandles ?? interactive) && interactive;
	const segments = selectedSegments(fromMin, toMin, durationMin);
	useEffect(() => {
		if (!interactive) return;
		const moveDrag = (clientX) => {
			if (!dragEndRef.current || !trackRef.current) return;
			const next = minutesFromClientX(clientX, trackRef.current.getBoundingClientRect());
			if (dragEndRef.current === "from") onChangeFromRef.current?.(next);
			else onChangeToRef.current?.(next);
		};
		const onMove = (event) => {
			if (!dragEndRef.current) return;
			moveDrag(event.clientX);
		};
		const endDrag = () => {
			dragEndRef.current = null;
		};
		window.addEventListener("pointermove", onMove);
		window.addEventListener("pointerup", endDrag);
		window.addEventListener("pointercancel", endDrag);
		return () => {
			window.removeEventListener("pointermove", onMove);
			window.removeEventListener("pointerup", endDrag);
			window.removeEventListener("pointercancel", endDrag);
		};
	}, [interactive]);
	const startDrag = (end) => (event) => {
		event.preventDefault();
		dragEndRef.current = end;
		event.currentTarget.setPointerCapture?.(event.pointerId);
	};
	const onKeyDown = (end, current) => (event) => {
		const step = event.key === "ArrowRight" ? 30 : event.key === "ArrowLeft" ? -30 : 0;
		if (!step) return;
		event.preventDefault();
		const next = stepMinutes(current, step);
		if (end === "from") onChangeFrom?.(next);
		else onChangeTo?.(next);
	};
	return /* @__PURE__ */ jsxs("div", {
		className: "space-y-xxs",
		children: [
			periodTrackVisible && /* @__PURE__ */ jsxs("div", {
				className: "relative h-[1lh] w-full text-sm",
				ref: trackRef,
				children: [/* @__PURE__ */ jsxs("div", {
					className: "border-text-subtle bg-surface-strong absolute inset-0 overflow-hidden rounded-full border",
					children: [segments.map((segment) => /* @__PURE__ */ jsx("div", {
						className: "bg-main/50 absolute top-0 h-full",
						style: {
							left: `${minutesToPercent(segment.start)}%`,
							width: `${minutesToPercent(segment.end - segment.start)}%`
						}
					}, `${segment.start}-${segment.end}`)), /* @__PURE__ */ jsx("div", { className: "bg-neutral absolute top-0 left-1/2 h-full w-px" })]
				}), handlesVisible && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(TimelineHandle, {
					label: "From",
					min: fromMin,
					onKeyDown: onKeyDown("from", fromMin),
					onPointerDown: startDrag("from")
				}), /* @__PURE__ */ jsx(TimelineHandle, {
					label: "To",
					min: toMin,
					onKeyDown: onKeyDown("to", toMin),
					onPointerDown: startDrag("to")
				})] })]
			}),
			lanes,
			/* @__PURE__ */ jsxs("div", {
				className: "text-color-subtle relative text-xs",
				children: [/* @__PURE__ */ jsx("span", { children: "12a" }), /* @__PURE__ */ jsx("span", {
					className: "absolute left-1/2 -translate-x-1/2",
					children: "12p"
				})]
			})
		]
	});
}
//#endregion
export { DayTimelineRange };

//# sourceMappingURL=DayTimelineRange.js.map